webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(15);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueResource = __webpack_require__(95);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuefire = __webpack_require__(97);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	var _museUi = __webpack_require__(83);
	
	var _museUi2 = _interopRequireDefault(_museUi);
	
	__webpack_require__(71);
	
	var _App = __webpack_require__(85);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_museUi2.default);
	_vue2.default.use(_vuefire2.default);
	_vue2.default.use(_vueResource2.default);
	
	new _vue2.default({
	  router: _router2.default,
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports) {

	module.exports = L;

/***/ },
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(29)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _L = __webpack_require__(4);
	
	var _L2 = _interopRequireDefault(_L);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theSidebar = null;
	
	module.exports = function () {
	  if (!theSidebar) {
	    var sidebar = _L2.default.control.sidebar('sidebar', {
	      position: 'left'
	    });
	
	    theSidebar = sidebar;
	  }
	  return theSidebar;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Firebase = __webpack_require__(10);
	var GeoFire = __webpack_require__(79);
	
	var config = {
	  apiKey: 'AIzaSyC8yq1G_eUDEOW7e3ng2nCTlV90nZmeXSQ',
	  authDomain: 'product-board.firebaseapp.com',
	  databaseURL: 'https://product-board.firebaseio.com',
	  storageBucket: 'product-board.appspot.com',
	  messagingSenderId: '694238730184'
	};
	var firebaseInit = Firebase.initializeApp(config);
	
	var firebaseApp = {
	  auth: firebaseInit.auth(),
	  db: firebaseInit.database(),
	  storage: firebaseInit.storage(),
	  geoFire: new GeoFire(firebaseInit.database().ref('/locations'))
	};
	
	module.exports = firebaseApp;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(96);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(88);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _MapPage = __webpack_require__(89);
	
	var _MapPage2 = _interopRequireDefault(_MapPage);
	
	var _ChatPage = __webpack_require__(86);
	
	var _ChatPage2 = _interopRequireDefault(_ChatPage);
	
	var _Example = __webpack_require__(87);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/',
	  redirect: { path: 'mapPage' }
	}, { path: '/home', component: _Home2.default }, { path: '/mapPage', component: _MapPage2.default }, { path: '/chatPage', component: _ChatPage2.default }, { path: '/example', component: _Example2.default }];
	
	exports.default = new _vueRouter2.default({
	  routes: routes
	});

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/sun.a646a52.jpg";

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _L = __webpack_require__(4);
	
	var _L2 = _interopRequireDefault(_L);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_L2.default.Icon.Default.imagePath = '/static/images/leaflet/images';
	
	var LeafIcon = _L2.default.Icon.extend({
	  options: {
	    iconSize: [64, 64]
	  }
	});
	
	module.exports = {
	  otherIcon: new LeafIcon({
	    iconUrl: '/static/images/singing.png'
	  }),
	  paintIcon: new LeafIcon({
	    iconUrl: '/static/images/painting.png'
	  }),
	  myIcon: new _L2.default.Icon.Default()
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _L = __webpack_require__(4);
	
	var _L2 = _interopRequireDefault(_L);
	
	__webpack_require__(82);
	
	__webpack_require__(70);
	
	__webpack_require__(80);
	
	__webpack_require__(81);
	
	__webpack_require__(69);
	
	var _myMarker = __webpack_require__(23);
	
	var _myMarker2 = _interopRequireDefault(_myMarker);
	
	var _utils = __webpack_require__(12);
	
	var _sidebar = __webpack_require__(13);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initMyMarker = null;
	module.exports = function (window) {
	  var isLogin = false;
	  var taiwanCenter = new _L2.default.LatLng(23.974093, 120.979903);
	
	  var map = new _L2.default.Map('map', {
	    center: taiwanCenter,
	    zoom: 8,
	    minZoom: 4
	  });
	
	  map.addLayer(new _L2.default.Google('ROADMAP'));
	  var markers = new _L2.default.MarkerClusterGroup();
	  map.addLayer(markers);
	  _L2.default.control.locate().addTo(map);
	  new _L2.default.Control.GeoSearch({
	    provider: new _L2.default.GeoSearch.Provider.OpenStreetMap()
	  }).addTo(map);
	
	  map.addControl((0, _sidebar2.default)());
	
	  map.taiwanCenter = taiwanCenter;
	
	  map.addPoint = function (obj) {
	    var key = obj.key;
	    var title = obj.title;
	    var location = obj.location;
	    var isMyPoint = obj.isMyPoint;
	    var pic = obj.pic;
	    var icon = _L2.default.icon({
	      iconUrl: pic,
	      iconSize: [64, 64],
	      className: 'custom_icon'
	    });
	    var marker = _L2.default.marker(location, { icon: icon, location_key: key, draggable: isMyPoint ? 'true' : null });
	    marker.bindPopup('<h3>' + title + '</h3>').openPopup();
	    marker.on('click', function (point) {
	      _utils.event.emit('showPoint', point);
	      if (initMyMarker) {
	        initMyMarker.destroy();
	      }
	    });
	    marker.on('drag', function (e) {
	      _utils.event.emit('setProductLocation', e.target.getLatLng());
	    });
	    markers.addLayer(marker);
	  };
	  map.resetMarkerClusterGroup = function () {
	    markers.clearLayers();
	  };
	
	  map.isLogin = function (tempIs) {
	    isLogin = tempIs;
	  };
	  map.locateSelf = function () {
	    map.locate({ setView: true, maxZoom: 16 });
	  };
	
	  map.on('click', function (e) {
	    (0, _sidebar2.default)().hide();
	    if (isLogin) {
	      if (initMyMarker) {
	        initMyMarker.destroy();
	      }
	      initMyMarker = (0, _myMarker2.default)(map, e.latlng);
	      _utils.event.emit('setLocationNumfunction', e.latlng);
	
	      initMyMarker.setLatLng(e.latlng).bindPopup('<button type="button" class="mu-raised-button" id="myMarker""><span class="mu-flat-button-label">點我開始輸入資訊</span></button>').openPopup();
	      document.getElementById('myMarker').addEventListener('click', function () {
	        if (isLogin) {
	          (0, _sidebar2.default)().show();
	        } else {
	          window.alert('登入後才可輸入資訊');
	        }
	      });
	    } else {
	      window.alert('登入後才可輸入資訊');
	    }
	  });
	
	  map.on('locationfound', function (e) {
	
	    _L2.default.marker(e.latlng).addTo(map);
	    map.setView(e.latlng, 13);
	  });
	
	  map.on('locationerror', function (e) {
	    window.alert(e.message);
	  });
	
	  return map;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _L = __webpack_require__(4);
	
	var _L2 = _interopRequireDefault(_L);
	
	var _icon = __webpack_require__(21);
	
	var _utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theMarker = null;
	module.exports = function (map, location) {
	  if (!theMarker) {
	    var point = location || map.taiwanCenter;
	
	    var myMarker = _L2.default.marker(point, { icon: _icon.myIcon, draggable: 'true' }).addTo(map);
	
	    _utils.event.emit('setLocationNumfunction', point);
	
	    myMarker.on('drag', function (e) {
	      _utils.event.emit('setLocationNumfunction', e.target.getLatLng());
	    });
	
	    myMarker.destroy = function () {
	      if (document.getElementById('myMarker')) {
	        document.getElementById('myMarker').removeEventListener('click', function () {
	          console.log('destory');
	        });
	      }
	      map.removeLayer(myMarker);
	      theMarker = null;
	    };
	    theMarker = myMarker;
	  }
	  return theMarker;
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	var Product = {
	  INIT: 0,
	  X18: 1,
	  TEST: 2,
	  DELETE: 3,
	  properties: {
	    0: { name: 'INIT', value: 0 },
	    1: { name: 'X18', value: 1 },
	    2: { name: 'TEST', value: 2 },
	    3: { name: 'DELETE', value: 3 }
	  }
	};
	module.exports = {
	  Product: Product
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      auth: false
	    };
	  },
	
	  created: function created() {}
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sun = __webpack_require__(20);
	
	var _sun2 = _interopRequireDefault(_sun);
	
	var _uicon = __webpack_require__(11);
	
	var _uicon2 = _interopRequireDefault(_uicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      title: '',
	      price: NaN,
	      address: '',
	      description: '',
	      keywords: '',
	      img: _sun2.default,
	      myron: _uicon2.default
	    };
	  },
	
	  computed: {
	    splitArray: function splitArray() {
	      return this.keywords.split(',');
	    }
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(10);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firebaseApp = __webpack_require__(14);
	
	var _sun = __webpack_require__(20);
	
	var _sun2 = _interopRequireDefault(_sun);
	
	var _uicon = __webpack_require__(11);
	
	var _uicon2 = _interopRequireDefault(_uicon);
	
	var _distance_in_words_to_now = __webpack_require__(19);
	
	var _distance_in_words_to_now2 = _interopRequireDefault(_distance_in_words_to_now);
	
	var _state = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productsRef = _firebaseApp.db.ref('products');
	
	exports.default = {
	  data: function data() {
	    return {
	      products: [],
	      title: '',
	      price: '',
	      address: '',
	      description: '',
	      keywords: '',
	      auth: null,
	      toast: false,
	      productPhoto: _sun2.default,
	      myron: _uicon2.default
	    };
	  },
	
	  computed: {
	    splitArray: function splitArray() {
	      return this.keywords.split(',');
	    },
	    productSplitArray: function productSplitArray() {
	      return this.products.map(function (product) {
	        return product.keywords ? product.keywords.split(',') : [];
	      });
	    },
	    productCreateTime: function productCreateTime() {
	      return this.products.map(function (product) {
	        return product.createTime ? (0, _distance_in_words_to_now2.default)(product.createTime) : '不知何時';
	      });
	    },
	    productDesc: function productDesc() {
	      return this.products.reverse();
	    },
	    productState: function productState() {
	      return this.products.map(function (product) {
	        return _state.Product.properties[product.state] ? _state.Product.properties[product.state].name : null;
	      });
	    }
	  },
	  methods: {
	    addProduct: function addProduct(e) {
	      e.preventDefault();
	      if (this.title && this.price && this.address) {
	        var currentUser = _firebaseApp.auth.currentUser;
	        productsRef.push({
	          productPhoto: this.productPhoto,
	          title: this.title,
	          price: this.price,
	          address: this.address,
	          description: this.description,
	          keywords: this.keywords,
	          userPhotoUrl: currentUser.photoURL,
	          userName: currentUser.displayName,
	          createTime: _firebase2.default.database.ServerValue.TIMESTAMP,
	          state: _state.Product.INIT
	        });
	        this.productPhoto = _sun2.default;
	        this.title = '';
	        this.price = '';
	        this.address = '';
	        this.description = '';
	        this.keywords = '';
	      }
	    },
	
	    updateProductState: function updateProductState(product, state) {
	      if (_firebaseApp.auth.currentUser) {
	        productsRef.child(product['.key']).child('state').set(state);
	      }
	    },
	    signIn: function signIn() {
	      var provider = new _firebase2.default.auth.GoogleAuthProvider();
	      _firebaseApp.auth.signInWithPopup(provider);
	    },
	    signOut: function signOut() {
	      _firebaseApp.auth.signOut();
	    },
	    checkSignedInWithMessage: function checkSignedInWithMessage() {
	      if (_firebaseApp.auth.currentUser) {
	        return true;
	      }
	
	      var data = {
	        message: 'You must sign-in first',
	        timeout: 2000
	      };
	      this.showToast(data);
	      return false;
	    },
	    saveImageMessage: function saveImageMessage(event) {
	      var _this = this;
	
	      var file = event.target.files[0];
	
	      if (!file.type.match('image.*')) {
	        var data = {
	          message: 'You can only share images',
	          timeout: 2000
	        };
	        this.showToast(data);
	        return;
	      }
	
	      if (this.checkSignedInWithMessage()) {
	        var currentUser = _firebaseApp.auth.currentUser;
	
	        _firebaseApp.storage.ref(currentUser.uid + '/' + Date.now() + '/' + file.name).put(file, { contentType: file.type }).then(function (snapshot) {
	          var filePath = snapshot.metadata.fullPath;
	          return _firebaseApp.storage.ref(filePath).getDownloadURL();
	        }).then(function (url) {
	          _this.productPhoto = url;
	        }).catch(function (error) {
	          console.error('There was an error uploading a file to Firebase Storage:', error);
	        });
	      }
	    },
	    showToast: function showToast(data) {
	      var _this2 = this;
	
	      this.toast = true;
	      this.toastmessage = data.message;
	      if (this.toastTimer) clearTimeout(this.toastTimer);
	      this.toastTimer = setTimeout(function () {
	        _this2.toast = false;
	      }, data.timeout);
	    },
	    hideToast: function hideToast() {
	      this.toast = false;
	      if (this.toastTimer) clearTimeout(this.toastTimer);
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this3 = this;
	
	    _firebaseApp.auth.onAuthStateChanged(function (user) {
	      _this3.auth = user;
	      _this3.$bindAsArray('products', productsRef.limitToLast(25));
	    });
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(22);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _firebase = __webpack_require__(10);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _firebaseApp = __webpack_require__(14);
	
	var _uicon = __webpack_require__(11);
	
	var _uicon2 = _interopRequireDefault(_uicon);
	
	var _distance_in_words_to_now = __webpack_require__(19);
	
	var _distance_in_words_to_now2 = _interopRequireDefault(_distance_in_words_to_now);
	
	var _utils = __webpack_require__(12);
	
	var _router = __webpack_require__(15);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _sidebar = __webpack_require__(13);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _Gossim = __webpack_require__(98);
	
	var _Gossim2 = _interopRequireDefault(_Gossim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productsRef = _firebaseApp.db.ref('products');
	var initMap = null;
	
	exports.default = {
	  data: function data() {
	    return {
	      bottomPopup: false,
	      open: false,
	      docked: true,
	      isUpload: false,
	      wantSell: false,
	      geokey: '',
	      products: {},
	      title: '',
	      price: '',
	      address: '',
	      description: '',
	      keywords: '',
	      currentUser: null,
	      toast: false,
	      point: {
	        lat: '',
	        lng: ''
	      },
	      productPhoto: '',
	      myron: _uicon2.default
	    };
	  },
	
	  computed: {
	    splitArray: function splitArray() {
	      return this.products[this.geokey].keywords.split(',');
	    },
	    productSplitArray: function productSplitArray() {
	      return this.products.map(function (product) {
	        return product.keywords ? product.keywords.split(',') : [];
	      });
	    },
	    productCreateTime: function productCreateTime() {
	      return this.products[this.geokey].createTime ? (0, _distance_in_words_to_now2.default)(this.products[this.geokey].createTime) : '不知何時';
	    }
	  },
	  methods: {
	    openAction: function openAction(e) {
	      this.bottomPopup = true;
	    },
	    closeAction: function closeAction() {
	      this.bottomPopup = false;
	    },
	    toggle: function toggle(flag) {
	      this.open = !this.open;
	      this.docked = !flag;
	    },
	    addProduct: function addProduct(state) {
	      var currentUser = _firebaseApp.auth.currentUser;
	      if (currentUser && this.title) {
	        var key = productsRef.push({
	          productPhoto: this.productPhoto,
	          title: this.title,
	          price: this.price,
	          address: this.address,
	          description: this.description,
	          keywords: this.keywords,
	          userUid: currentUser.uid,
	          userPhotoUrl: currentUser.photoURL,
	          userName: currentUser.displayName,
	          createTime: _firebase2.default.database.ServerValue.TIMESTAMP,
	          state: state
	        }).key;
	        _firebaseApp.geoFire.set(key, [this.point.lat, this.point.lng]).then(function () {
	          (0, _sidebar2.default)().hide();
	        });
	        this.productPhoto = '';
	        this.title = '';
	        this.price = '';
	        this.address = '';
	        this.description = '';
	        this.keywords = '';
	
	        _router2.default.replace({ path: 'mapPage',
	          query: {
	            state: state
	          }
	        });
	      } else {
	        this.showToast('至少也寫個標題吧？', 2000);
	      }
	    },
	
	    updateProductLocation: function updateProductLocation(key) {
	      if (_firebaseApp.auth.currentUser) {
	        _firebaseApp.geoFire.set(key, [this.point.lat, this.point.lng]).then(function () {
	          (0, _sidebar2.default)().hide();
	          window.alert('已更新這個地點的位置');
	        });
	      }
	    },
	    deleteProduct: function deleteProduct(key, state) {
	      if (_firebaseApp.auth.currentUser && window.confirm('確定要刪除這個板子？')) {
	        productsRef.child(key).child('state').set(3);
	        (0, _sidebar2.default)().hide();
	        window.alert('已移除這個地點');
	      }
	    },
	    signIn: function signIn() {
	      var provider = new _firebase2.default.auth.GoogleAuthProvider();
	      _firebaseApp.auth.signInWithPopup(provider);
	    },
	    fbSignIn: function fbSignIn() {
	      var provider = new _firebase2.default.auth.FacebookAuthProvider();
	      _firebaseApp.auth.signInWithPopup(provider);
	    },
	    signOut: function signOut() {
	      _firebaseApp.auth.signOut();
	    },
	    checkSignedInWithMessage: function checkSignedInWithMessage() {
	      if (_firebaseApp.auth.currentUser) {
	        return true;
	      }
	
	      var data = {
	        message: 'You must sign-in first',
	        timeout: 2000
	      };
	      this.showToast(data);
	      return false;
	    },
	    saveImageMessage: function saveImageMessage(event) {
	      var _this = this;
	
	      var file = event.target.files[0];
	
	      if (!file.type.match('image.*')) {
	        var data = {
	          message: 'You can only share images',
	          timeout: 2000
	        };
	        this.showToast(data);
	        return;
	      }
	
	      if (this.checkSignedInWithMessage()) {
	        this.isUpload = true;
	
	        var currentUser = _firebaseApp.auth.currentUser;
	
	        _firebaseApp.storage.ref(currentUser.uid + '/' + Date.now() + '/' + file.name).put(file, { contentType: file.type }).then(function (snapshot) {
	          var filePath = snapshot.metadata.fullPath;
	          return _firebaseApp.storage.ref(filePath).getDownloadURL();
	        }).then(function (url) {
	          _this.isUpload = false;
	          _this.productPhoto = url;
	        }).catch(function (error) {
	          console.error('There was an error uploading a file to Firebase Storage:', error);
	        });
	      }
	    },
	    showToast: function showToast(data) {
	      var _this2 = this;
	
	      this.toast = true;
	      this.toastmessage = data.message;
	      if (this.toastTimer) clearTimeout(this.toastTimer);
	      this.toastTimer = setTimeout(function () {
	        _this2.toast = false;
	      }, data.timeout);
	    },
	    hideToast: function hideToast() {
	      this.toast = false;
	      if (this.toastTimer) clearTimeout(this.toastTimer);
	    },
	    showSidebar: function showSidebar(key, latlng) {
	      this.wantSell = false;
	      this.geokey = key;
	      this.point = latlng;
	      if (!(0, _sidebar2.default)().isVisible()) {
	        (0, _sidebar2.default)().show();
	        this.isUserOnline(this.products[this.geokey].userUid);
	      }
	    },
	    loadProduct: function loadProduct(state) {
	      _router2.default.replace({ path: 'mapPage',
	        query: {
	          state: state
	        }
	      });
	      this.initProduct(state);
	    },
	    initProduct: function initProduct(state) {
	      var _this3 = this;
	
	      initMap.resetMarkerClusterGroup();
	      var setProduct = function setProduct(data) {
	        var val = data.val();
	        var key = data.key;
	        _this3.products[key] = val;
	        _firebaseApp.geoFire.get(key).then(function (location) {
	          if (location === null) {
	            console.log('Provided key is not in GeoFire');
	          } else {
	            initMap.addPoint({ key: key, title: val.title, location: location, pic: val.productPhoto || val.userPhotoUrl, isMyPoint: _firebaseApp.auth.currentUser && val.userUid === _firebaseApp.auth.currentUser.uid });
	          }
	        });
	      };
	      productsRef.orderByChild('state').equalTo(state).limitToLast(100).on('child_added', setProduct);
	    },
	    gossimOpen: function gossimOpen(uid, name) {
	      _Gossim2.default.popup(uid, name);
	    },
	    isUserOnline: function isUserOnline(id) {
	      var _this4 = this;
	
	      _Gossim2.default.isUserOnline(id, function (returnId, isOnline) {
	        _this4.products[_this4.geokey].userLoginStatus = isOnline;
	      });
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    var _this5 = this;
	
	    _utils.event.init();
	    _utils.event.on('setLocationNumfunction', function (point) {
	      _this5.wantSell = true;
	      _this5.point = point;
	    });
	    _utils.event.on('setProductLocation', function (point) {
	      _this5.point = point;
	    });
	    _utils.event.on('showPoint', function (point) {
	      var key = point.target.options.location_key;
	      _this5.showSidebar(key, point.latlng);
	
	      var query = { product_id: key };
	      if (_this5.$route.query.state) {
	        query.state = _this5.$route.query.state;
	      }
	
	      _router2.default.replace({ path: 'mapPage',
	        query: query
	      });
	    });
	  },
	  mounted: function mounted() {
	    var _this6 = this;
	
	    initMap = (0, _map2.default)(window);
	    initMap.locateSelf();
	    _firebaseApp.auth.onAuthStateChanged(function (user) {
	      _this6.currentUser = user;
	      initMap.isLogin(user);
	      if (user) {
	        _Gossim2.default.setUserInfo({
	          id: user.uid,
	          name: user.displayName,
	          image: user.photoURL,
	          email: user.email
	        });
	      }
	
	      var productId = _this6.$route.query.product_id;
	      if (productId) {
	        productsRef.orderByKey().equalTo(productId).on('child_added', function (data) {
	          var val = data.val();
	          var key = data.key;
	          _this6.products[key] = val;
	          _firebaseApp.geoFire.get(key).then(function (location) {
	            _this6.showSidebar(key, { lat: location[0], lng: location[1] });
	          });
	        });
	      }
	      var state = _this6.$route.query.state;
	      if (state) {
	        _this6.initProduct(parseInt(state));
	      } else {
	        _this6.loadProduct(0);
	      }
	    });
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.event = undefined;
	
	var _keys = __webpack_require__(30);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var event = {
	  bus: null,
	  init: function init() {
	    if (!this.bus) {
	      this.bus = new _vue2.default();
	    }
	
	    return this;
	  },
	  emit: function emit(name) {
	    var _bus;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_bus = this.bus).$emit.apply(_bus, [name].concat(args));
	    return this;
	  },
	  on: function on() {
	    var _this = this,
	        _arguments = arguments;
	
	    if (arguments.length === 2) {
	      this.bus.$on(arguments[0], arguments[1]);
	    } else {
	      (0, _keys2.default)(arguments[0]).forEach(function (key) {
	        _this.bus.$on(key, _arguments[0][key]);
	      });
	    }
	
	    return this;
	  }
	};
	
	exports.event = event;

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 70 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 71 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 72 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(25)
	
	/* template */
	var __vue_template__ = __webpack_require__(93)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(94)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(74)
	
	/* script */
	__vue_exports__ = __webpack_require__(26)
	
	/* template */
	var __vue_template__ = __webpack_require__(92)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(73)
	
	/* script */
	__vue_exports__ = __webpack_require__(27)
	
	/* template */
	var __vue_template__ = __webpack_require__(91)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(72)
	
	/* script */
	__vue_exports__ = __webpack_require__(28)
	
	/* template */
	var __vue_template__ = __webpack_require__(90)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', [(_vm.toast) ? _h('mu-toast', {
	    attrs: {
	      "message": _vm.toastmessage
	    },
	    on: {
	      "close": _vm.hideToast
	    }
	  }) : _vm._e(), " ", _h('mu-drawer', {
	    attrs: {
	      "open": _vm.open,
	      "docked": _vm.docked
	    },
	    on: {
	      "close": function($event) {
	        _vm.toggle()
	      }
	    }
	  }, [_h('mu-list', {
	    on: {
	      "itemClick": function($event) {
	        _vm.docked ? '' : _vm.toggle()
	      }
	    }
	  }, [_h('mu-menu-item', {
	    attrs: {
	      "title": "使用說明"
	    },
	    on: {
	      "click": _vm.openAction
	    }
	  }), " ", (!_vm.currentUser) ? _h('mu-menu-item', {
	    attrs: {
	      "title": "FB登入"
	    },
	    on: {
	      "click": _vm.fbSignIn
	    }
	  }) : _vm._e(), " ", (!_vm.currentUser) ? _h('mu-menu-item', {
	    attrs: {
	      "title": "Google登入"
	    },
	    on: {
	      "click": _vm.signIn
	    }
	  }) : _vm._e(), " ", (_vm.currentUser) ? _h('mu-menu-item', {
	    attrs: {
	      "title": "登出"
	    },
	    on: {
	      "click": _vm.signOut
	    }
	  }) : _vm._e(), " ", _h('mu-menu-item', {
	    attrs: {
	      "title": ""
	    }
	  }), " ", _h('mu-menu-item', {
	    attrs: {
	      "title": "正常版"
	    },
	    on: {
	      "click": function($event) {
	        _vm.loadProduct(0)
	      }
	    }
	  }), " ", _h('mu-menu-item', {
	    attrs: {
	      "title": "歡樂測試版"
	    },
	    on: {
	      "click": function($event) {
	        _vm.loadProduct(2)
	      }
	    }
	  }), " ", _h('mu-menu-item', {
	    attrs: {
	      "title": "",
	      "href": "/#/chatPage"
	    }
	  })])]), " ", _h('mu-appbar', [_h('mu-icon-button', {
	    attrs: {
	      "icon": "menu"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggle(true)
	      }
	    },
	    slot: "left"
	  }), " ", _h('mu-sub-header', [_h('h1', ["地圖佈告欄"])]), " ", (!_vm.currentUser) ? _h('mu-flat-button', {
	    attrs: {
	      "color": "white",
	      "label": "Login"
	    },
	    on: {
	      "click": _vm.fbSignIn
	    },
	    slot: "right"
	  }) : _vm._e(), " ", (_vm.currentUser) ? _h('mu-flat-button', {
	    attrs: {
	      "color": "white",
	      "label": _vm.currentUser.displayName
	    },
	    on: {
	      "click": function($event) {}
	    },
	    slot: "right"
	  }) : _vm._e()]), " ", _h('div', {
	    attrs: {
	      "id": "map"
	    }
	  }), " ", _h('div', {
	    attrs: {
	      "id": "sidebar"
	    }
	  }, [(_vm.currentUser && _vm.wantSell) ? _h('div', [_h('h1', ["在這裡寫下你想做的事吧"]), " ", _h('mu-content-block', [_h('div', {
	    staticClass: "demo-grid"
	  }, [_h('mu-raised-button', {
	    staticClass: "demo-raised-button",
	    attrs: {
	      "label": "上傳圖片"
	    }
	  }, [_h('input', {
	    staticClass: "file-button",
	    attrs: {
	      "accept": "image/*,capture=camera",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.saveImageMessage
	    }
	  })]), _h('br'), " ", (_vm.isUpload) ? _h('mu-circular-progress', {
	    attrs: {
	      "size": 40
	    }
	  }) : _vm._e(), _h('br'), " ", (_vm.productPhoto) ? _h('mu-card-media', [_h('img', {
	    staticClass: "product-photo",
	    attrs: {
	      "src": _vm.productPhoto
	    }
	  })]) : _vm._e(), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "label": "標題(物品，服務等)",
	      "type": "text",
	      "errorText": (!_vm.title) ? '不可空白' : '',
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        _vm.title = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.price),
	      expression: "price"
	    }],
	    attrs: {
	      "label": "費用",
	      "type": "number",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.price)
	    },
	    on: {
	      "input": function($event) {
	        _vm.price = _vm._n($event)
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    attrs: {
	      "hintText": "敘述你的物品或服務內容吧，如：尺寸，顏色",
	      "multiLine": "",
	      "rows": 4
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        _vm.description = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address),
	      expression: "address"
	    }],
	    attrs: {
	      "label": "概略地點 (optional)",
	      "type": "text",
	      "hintText": "如：台北市大安區",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.address)
	    },
	    on: {
	      "input": function($event) {
	        _vm.address = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywords),
	      expression: "keywords"
	    }],
	    attrs: {
	      "label": "關鍵字 (optional)",
	      "type": "text",
	      "hintText": "逗點分隔關鍵字，如：nike,puma...",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.keywords)
	    },
	    on: {
	      "input": function($event) {
	        _vm.keywords = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-raised-button', {
	    staticClass: "demo-raised-button",
	    attrs: {
	      "label": "送出",
	      "primary": ""
	    },
	    on: {
	      "enter": function($event) {
	        _vm.addProduct(0)
	      },
	      "click": function($event) {
	        _vm.addProduct(0)
	      }
	    }
	  }), " ", _h('mu-raised-button', {
	    staticClass: "demo-raised-button",
	    attrs: {
	      "label": "歡樂測試版",
	      "primary": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.addProduct(2)
	      }
	    }
	  })])]), " ", _h('mu-content-block', [_h('h3', ["預覽："]), " ", _h('mu-card', [_h('mu-card-media', [_h('img', {
	    staticClass: "product-photo",
	    attrs: {
	      "src": _vm.productPhoto
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": _vm.title,
	      "subTitle": (_vm.price) ? ' NT$' + _vm.price : ''
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_h('pre', [_vm._s(_vm.description)]), "\n\t                " + _vm._s((_vm.address) ? '地點：' + _vm.address : '') + "\n\t              "]), " ", (_vm.keywords.length > 0) ? _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_vm._l((_vm.keywords.split(',')), function(keyword) {
	    return _h('div', [_h('span', [_h('a', {
	      attrs: {
	        "href": '#' + keyword
	      }
	    }, ["#" + _vm._s(keyword)])])])
	  })]) : _vm._e(), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "剛剛建立",
	      "subTitle": '來自 ' + _vm.currentUser.displayName
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.currentUser.photoURL
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-sub-header', {
	    staticStyle: {
	      "color": "#f1efef"
	    }
	  }, ["(" + _vm._s(_vm.point.lat) + " " + _vm._s(_vm.point.lng) + ")"])])])]) : (_vm.products[_vm.geokey]) ? _h('div', [_h('h1', ["這裡有塊板子上面寫著："]), " ", _h('mu-card', [_h('mu-card-media', [_h('img', {
	    staticClass: "product-photo",
	    attrs: {
	      "src": _vm.products[_vm.geokey].productPhoto
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": _vm.products[_vm.geokey].title,
	      "subTitle": (_vm.products[_vm.geokey].price) ? ' NT$' + _vm.products[_vm.geokey].price : ''
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_h('pre', [_vm._s(_vm.products[_vm.geokey].description)]), "\n                " + _vm._s((_vm.products[_vm.geokey].address) ? '地點：' + _vm.products[_vm.geokey].address : '') + "\n              "]), " ", (this.products[this.geokey].keywords.length > 0) ? _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_vm._l((_vm.splitArray), function(keyword) {
	    return _h('div', [_h('span', [_h('a', {
	      attrs: {
	        "href": '#' + keyword
	      }
	    }, ["#" + _vm._s(keyword)])])])
	  })]) : _vm._e(), " ", _h('mu-card-header', {
	    attrs: {
	      "title": _vm.productCreateTime + ' 前建立',
	      "subTitle": '來自 ' + _vm.products[_vm.geokey].userName
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.products[_vm.geokey].userPhotoUrl
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [(!_vm.currentUser || _vm.currentUser.uid !== _vm.products[_vm.geokey].userUid) ? _h('mu-raised-button', {
	    attrs: {
	      "label": '丟訊息問問 ' + _vm.products[_vm.geokey].userName
	    },
	    on: {
	      "click": function($event) {
	        _vm.gossimOpen(_vm.products[_vm.geokey].userUid, _vm.products[_vm.geokey].userName)
	      }
	    }
	  }) : _vm._e(), (!_vm.currentUser || _vm.currentUser.uid !== _vm.products[_vm.geokey].userUid) ? _h('span', ["(此人" + _vm._s(_vm.products[_vm.geokey].userLoginStatus ? '在線上' : '離線') + ")"]) : _vm._e()]), " ", (_vm.currentUser && _vm.currentUser.uid === _vm.products[_vm.geokey].userUid) ? _h('mu-card-actions', [_h('mu-raised-button', {
	    attrs: {
	      "label": "移動你的板子後，儲存位置。"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateProductLocation(_vm.geokey)
	      }
	    }
	  }), _h('br'), _h('br'), " ", _h('mu-raised-button', {
	    attrs: {
	      "label": "刪除這塊留言板。",
	      "secondary": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.deleteProduct(_vm.geokey)
	      }
	    }
	  })]) : _vm._e(), " ", _h('mu-sub-header', {
	    staticStyle: {
	      "color": "white"
	    }
	  }, ["位於 " + _vm._s(_vm.point.lat) + " " + _vm._s(_vm.point.lng)])])]) : _vm._e(), " ", " ", " ", _h('mu-popup', {
	    attrs: {
	      "popupClass": "demo-popup-bottom",
	      "open": _vm.bottomPopup
	    },
	    on: {
	      "close": _vm.closeAction
	    }
	  }, [_h('mu-appbar', {
	    attrs: {
	      "title": "使用說明"
	    }
	  }, [_h('mu-flat-button', {
	    attrs: {
	      "label": "關閉",
	      "color": "white"
	    },
	    on: {
	      "click": _vm.closeAction
	    },
	    slot: "right"
	  })]), " ", _h('mu-content-block', [_h('h3', ["操作方式："]), " ", _h('p', ["\n          未登入時，可觀看附近的留言板。\n          登入時，可任意在地圖上加入，移動，刪除留言板。\n          可與對方私訊交談，即使對方不在線上也會寄信通知。\n        "]), " ", _h('h3', ["作者："]), " ", _h('p', ["\n          Created by ", _h('a', {
	    attrs: {
	      "href": "https://www.facebook.com/yijuwu"
	    }
	  }, ["Mark"]), ".", _h('br'), "\n          連結", _h('a', {
	    attrs: {
	      "href": "https://www.facebook.com/yijuwu"
	    }
	  }, ["https://www.facebook.com/yijuwu"]), _h('br'), "\n          有任何問題或改進方案都可以提供給我，謝謝！\n        "])])])])])
	},staticRenderFns: []}

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', [(_vm.toast) ? _h('mu-toast', {
	    attrs: {
	      "message": _vm.toastmessage
	    },
	    on: {
	      "close": _vm.hideToast
	    }
	  }) : _vm._e(), " ", _h('mu-appbar', {
	    attrs: {
	      "title": "產品列表"
	    }
	  }, [_h('mu-flat-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.auth),
	      expression: "!auth"
	    }],
	    attrs: {
	      "color": "white",
	      "label": "Fb Login"
	    },
	    on: {
	      "click": _vm.signIn
	    },
	    slot: "right"
	  }), " ", _h('mu-flat-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.auth),
	      expression: "auth"
	    }],
	    attrs: {
	      "color": "white",
	      "label": "Sign Out"
	    },
	    on: {
	      "click": _vm.signOut
	    },
	    slot: "right"
	  })]), " ", _h('mu-content-block', [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('h1', ["所有物品"])])]), " ", _h('div', {
	    staticClass: "demo-grid"
	  }, [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_vm._l((_vm.productDesc), function(product, index) {
	    return (_vm.products.length > 0) ? _h('mu-col', {
	      attrs: {
	        "width": "100",
	        "tablet": "50",
	        "desktop": "33"
	      }
	    }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	      staticClass: "product-photo",
	      attrs: {
	        "src": product.productPhoto
	      }
	    })]), " ", _h('mu-card-title', {
	      attrs: {
	        "title": product.title,
	        "subTitle": ' NT$' + product.price
	      }
	    }), " ", _h('mu-card-text', {
	      staticClass: "text-align-left"
	    }, ["\n                狀態：" + _vm._s(_vm.productState[index]), _h('br'), "\n                地點：" + _vm._s(product.address) + "\n                ", _h('pre', [_vm._s(product.description)])]), " ", _h('mu-card-text', {
	      staticClass: "text-align-left"
	    }, [_vm._l((_vm.productSplitArray[index]), function(keyword) {
	      return _h('div', [_h('span', [_h('a', {
	        attrs: {
	          "href": '#' + keyword
	        }
	      }, ["#" + _vm._s(keyword)])])])
	    })]), " ", _h('mu-card-header', {
	      attrs: {
	        "title": _vm.productCreateTime[index] + ' 前建立',
	        "subTitle": '來自 ' + product.userName
	      }
	    }, [_h('mu-avatar', {
	      attrs: {
	        "src": product.userPhotoUrl
	      },
	      slot: "avatar"
	    })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	      attrs: {
	        "label": "INIT"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateProductState(product, 0)
	        }
	      }
	    }), " ", _h('mu-flat-button', {
	      attrs: {
	        "label": "X18"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateProductState(product, 1)
	        }
	      }
	    }), " ", _h('mu-flat-button', {
	      attrs: {
	        "label": "TEST"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateProductState(product, 2)
	        }
	      }
	    }), " ", _h('mu-flat-button', {
	      attrs: {
	        "label": "DELETE"
	      },
	      on: {
	        "click": function($event) {
	          _vm.updateProductState(product, 3)
	        }
	      }
	    })]), " "])]) : _vm._e()
	  })])])]), " ", _h('mu-content-block', [_h('div', {
	    staticClass: "demo-grid"
	  }, [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_h('mu-col', {
	    attrs: {
	      "width": "0",
	      "tablet": "0",
	      "desktop": "20"
	    }
	  }), " ", (_vm.auth) ? _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "30"
	    }
	  }, [_h('mu-raised-button', {
	    staticClass: "demo-raised-button",
	    attrs: {
	      "label": "上傳圖片"
	    }
	  }, [_h('input', {
	    staticClass: "file-button",
	    attrs: {
	      "accept": "image/*,capture=camera",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.saveImageMessage
	    }
	  })]), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "label": "物品名稱",
	      "type": "text",
	      "errorText": (!_vm.title) ? '不可空白' : '',
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        _vm.title = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.price),
	      expression: "price"
	    }],
	    attrs: {
	      "label": "價格",
	      "type": "number",
	      "errorText": (!_vm.price) ? '不可空白' : '',
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.price)
	    },
	    on: {
	      "input": function($event) {
	        _vm.price = _vm._n($event)
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address),
	      expression: "address"
	    }],
	    attrs: {
	      "label": "地點",
	      "type": "text",
	      "hintText": "如：台北市大安區",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.address)
	    },
	    on: {
	      "input": function($event) {
	        _vm.address = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    attrs: {
	      "hintText": "(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色",
	      "multiLine": "",
	      "rows": 4
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        _vm.description = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywords),
	      expression: "keywords"
	    }],
	    attrs: {
	      "label": "關鍵字",
	      "type": "text",
	      "hintText": "逗點分隔關鍵字，如：nike,puma...",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.keywords)
	    },
	    on: {
	      "input": function($event) {
	        _vm.keywords = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-raised-button', {
	    staticClass: "demo-raised-button",
	    attrs: {
	      "label": "送出",
	      "primary": ""
	    },
	    on: {
	      "click": _vm.addProduct
	    }
	  })]) : _vm._e(), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "30"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    staticClass: "product-photo",
	    attrs: {
	      "src": _vm.productPhoto
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": _vm.title,
	      "subTitle": ' NT$' + _vm.price
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n                地點：" + _vm._s(_vm.address) + "\n                ", _h('pre', [_vm._s(_vm.description)])]), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_vm._l((_vm.splitArray), function(keyword) {
	    return _h('div', [_h('span', [_h('a', {
	      attrs: {
	        "href": '#' + keyword
	      }
	    }, ["#" + _vm._s(keyword)])])])
	  })]), " ", (_vm.auth) ? _h('mu-card-header', {
	    attrs: {
	      "title": "幾秒 前建立",
	      "subTitle": '來自 ' + _vm.auth.displayName
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.auth.photoURL
	    },
	    slot: "avatar"
	  })]) : _vm._e(), " ", _h('mu-card-actions', [(_vm.auth) ? _h('mu-flat-button', {
	    attrs: {
	      "label": '丟訊息問問 ' + _vm.auth.displayName
	    }
	  }) : _vm._e()])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "0",
	      "tablet": "0",
	      "desktop": "20"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', [_h('mu-appbar', {
	    attrs: {
	      "title": "產品列表"
	    }
	  }), " ", _h('mu-content-block', [_h('div', {
	    staticClass: "demo-grid"
	  }, [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_h('mu-col', {
	    attrs: {
	      "width": "0",
	      "tablet": "0",
	      "desktop": "20"
	    }
	  }), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "30"
	    }
	  }, [_h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "label": "物品名稱",
	      "type": "text",
	      "errorText": "不可空白",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        _vm.title = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.price),
	      expression: "price"
	    }],
	    attrs: {
	      "label": "價格",
	      "type": "number",
	      "errorText": "不可空白",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.price)
	    },
	    on: {
	      "input": function($event) {
	        _vm.price = _vm._n($event)
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address),
	      expression: "address"
	    }],
	    attrs: {
	      "label": "地點",
	      "type": "text",
	      "hintText": "如：台北市大安區",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.address)
	    },
	    on: {
	      "input": function($event) {
	        _vm.address = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    attrs: {
	      "hintText": "(選擇性填寫)敘述你要賣的物品吧，如：尺寸，顏色",
	      "multiLine": "",
	      "rows": 4
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        _vm.description = $event
	      }
	    }
	  }), _h('br'), " ", _h('mu-text-field', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keywords),
	      expression: "keywords"
	    }],
	    attrs: {
	      "label": "關鍵字",
	      "type": "text",
	      "hintText": "逗點分隔關鍵字，如：nike,puma...",
	      "labelFloat": ""
	    },
	    domProps: {
	      "value": (_vm.keywords)
	    },
	    on: {
	      "input": function($event) {
	        _vm.keywords = $event
	      }
	    }
	  }), _h('br')]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "30"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": _vm.title,
	      "subTitle": ' NT$' + _vm.price
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              地點：" + _vm._s(_vm.address) + "\n              ", _h('pre', [_vm._s(_vm.description)])]), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, [_vm._l((_vm.splitArray), function(keyword) {
	    return _h('div', [_h('span', [_h('a', {
	      attrs: {
	        "href": '#' + keyword
	      }
	    }, ["#" + _vm._s(keyword)])])])
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "丟訊息問問 Wu Yi-Ju"
	    }
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "0",
	      "tablet": "0",
	      "desktop": "20"
	    }
	  })])])]), " ", _h('mu-content-block', [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('h1', ["所有物品"])])]), " ", _h('div', {
	    staticClass: "demo-grid"
	  }, [_h('mu-row', {
	    attrs: {
	      "gutter": ""
	    }
	  }, [_h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break lines within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.The overflow-wrap property is used to specify whether or not the browser may break linesasdhfaioshdfliuahsdlifuhIGWRUHIRAUHGAILERUHGLIRAUEHGLIERUHFASDFHASODFHOADS within words in order to prevent overflow when an otherwise unbreakable string is too long to fit in its containing box.", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])]), " ", _h('mu-col', {
	    attrs: {
	      "width": "100",
	      "tablet": "50",
	      "desktop": "33"
	    }
	  }, [_h('mu-card', [_h('mu-card-media', [_h('img', {
	    attrs: {
	      "src": _vm.img
	    }
	  })]), " ", _h('mu-card-title', {
	    attrs: {
	      "title": "櫃子 $ 500",
	      "subTitle": "地點：台北縣新莊區"
	    }
	  }), " ", _h('mu-card-text', {
	    staticClass: "text-align-left"
	  }, ["\n              狀況：二手", _h('br'), "\n              尺寸：140x180x41 cm", _h('br'), "\n              顏色：白色", _h('br'), "\n              使用一切正常，意者自取", _h('br'), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#aa"])]), " ", _h('span', [_h('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, ["#bb"])])]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "5小時前 建立",
	      "subTitle": "來自 Wu Yi-Ju"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-actions', [_h('mu-flat-button', {
	    attrs: {
	      "label": "詢問"
	    }
	  })]), " ", _h('mu-sub-header', ["公開討論"]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })]), " ", _h('mu-card-header', {
	    attrs: {
	      "title": "Myron Avatar",
	      "subTitle": "哈囉你好"
	    }
	  }, [_h('mu-avatar', {
	    attrs: {
	      "src": _vm.myron
	    },
	    slot: "avatar"
	  })])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('router-view', {
	    staticClass: "view"
	  })])
	},staticRenderFns: []}

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticStyle: {
	      "height": "100vh"
	    },
	    attrs: {
	      "gs-wrap": ""
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ function(module, exports) {

	module.exports = Gossim;

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.78a72056e0317cc798b1.js